// tslint:disable
export var TCSRelationshipType;
(function (TCSRelationshipType) {
    // Parent
    TCSRelationshipType[TCSRelationshipType["Parent"] = 0] = "Parent";
    // Legal Guardian
    TCSRelationshipType[TCSRelationshipType["LegalGuardian"] = 1] = "LegalGuardian";
    // Other
    TCSRelationshipType[TCSRelationshipType["Other"] = 2] = "Other";
})(TCSRelationshipType || (TCSRelationshipType = {}));
TCSRelationshipType['PARENT'] = 0;
TCSRelationshipType['LEGALGUARDIAN'] = 1;
TCSRelationshipType['OTHER'] = 2;
//# sourceMappingURL=TCSRelationshipType.js.map